export const FACET_LABELS = {
	customerTypes: 'Kundentyp',
	businessModel: 'Geschäftsmodell',
	offerings: 'Leistung',
	specializations: 'Spezialisierung',
	serviceArea: 'Servicegebiet',
	tech: 'Technik',
	hiringActive: 'Stellt ein',
	hiringWebsite: 'Stellt ein',
	hiringOccupations: 'Berufsfeld',
	targetIndustries: 'Zielbranche',
	teamSize: 'Teamgröße laut Website',
	oldestCeoAge: 'Alter ältester GF',
	youngestCeoAge: 'Alter jüngster GF',
	discoverySource: 'Quelle',
};

const VOCABULARY_LIST_BY_FACET = {
	customerTypes: 'customerTypes',
	businessModel: 'businessModels',
	offerings: 'offerings',
	serviceArea: 'serviceAreas',
	tech: 'tech',
	oldestCeoAge: 'ageBuckets',
	youngestCeoAge: 'ageBuckets',
	hiringOccupations: 'occupations',
	discoverySource: 'discoverySources',
	companyKinds: 'companyKinds',
};

// The vocabulary lists only the searchable service areas, while stored profiles carry all of them.
const EXTRA_VALUE_LABELS = {
	serviceArea: { local: 'Lokal', unknown: 'Unbekannt' },
	hiringActive: { true: 'Ja' },
	hiringWebsite: { true: 'Ja' },
};

/**
 * German label of one facet value, falling back to the raw value while the vocabulary is
 * loading or when it does not know the value.
 * @param {Object|undefined} vocabulary - Response of GET /search/targeting/vocabulary
 * @param {string} facet - Facet key as used in search parameters and stored facets
 * @param {string|boolean} value
 * @returns {string}
 */
export const facetValueLabel = (vocabulary, facet, value) => {
	const rows = vocabulary?.[VOCABULARY_LIST_BY_FACET[facet]] ?? [];
	const row = rows.find((entry) => entry.value === value);
	return row?.label ?? EXTRA_VALUE_LABELS[facet]?.[String(value)] ?? String(value);
};

/**
 * Whether a facet may be offered as a hard filter. Website-profile attributes are offered only
 * when the vocabulary grades them 'strict' (hint attributes are searched via the full text);
 * attributes without a grade (hiring, occupations) always, once the vocabulary is loaded.
 * @param {Object|undefined} vocabulary
 * @param {string} facet
 * @returns {boolean}
 */
export const isOfferedFacet = (vocabulary, facet) => {
	const grade = vocabulary?.filterGrade?.[facet];
	return grade === undefined ? Boolean(vocabulary) : grade === 'strict';
};

export const HINT_VALUE_TITLE = 'Wird noch nicht zuverlässig erkannt und kann deshalb nicht gefiltert werden.';

const optionHint = (row) => {
	if (row.filterable === false) return { disabled: true, title: HINT_VALUE_TITLE };
	return row.description ? { title: row.description } : {};
};

// Hint values (filterable: false) are offered greyed out and can never be picked as filters.
export const vocabularyOptions = (rows = []) =>
	rows.map((row) => ({ value: row.value, label: row.label, ...optionHint(row) }));
